<div
  class="merge-dialog mergeToolBody"
  role="dialog"
  aria-modal="true"
  aria-labelledby="mergetool-title"
  aria-describedby="mergetool-explanation"
  data-cy="mergetool">
  <div class="merge-header">
    <i aria-hidden="true" class="icon-triangle-exclamation merge-header-icon"></i>
    <div class="merge-header-text">
      <div id="mergetool-title" class="merge-title">{{ 'mergetool.title' | translate }}</div>
      <p id="mergetool-explanation" class="merge-explanation">{{ 'mergetool.explanation' | translate }}</p>
      @if (remoteUpdatedBy || remoteUpdated) {
        <p class="merge-remote-info" data-cy="mergetool-remote-info">
          @if (remoteUpdatedBy && remoteUpdated) {
            {{ 'mergetool.remoteModifiedByOn' | translate: { user: remoteUpdatedBy, date: remoteUpdated } }}
          } @else if (remoteUpdatedBy) {
            {{ 'mergetool.remoteModifiedBy' | translate: { user: remoteUpdatedBy } }}
          } @else {
            {{ 'mergetool.remoteModifiedOn' | translate: { date: remoteUpdated } }}
          }
        </p>
      }
    </div>
  </div>

  <div class="merge-toolbar">
    <span class="merge-count" data-cy="mergetool-count">
      {{ 'mergetool.conflictCount' | translate: { count: dataToMerge.fields.length } }}
    </span>
    <span class="merge-hint">{{ 'mergetool.unchosenHint' | translate }}</span>
  </div>

  <div class="merge-body">
    <table class="merge-table">
      <thead>
        <tr>
          <th scope="col">{{ 'mergetool.field' | translate }}</th>
          <th scope="col">{{ 'mergetool.localColumn' | translate }}</th>
          <th scope="col">{{ 'mergetool.mergedColumn' | translate }}</th>
          <th scope="col">{{ 'mergetool.remoteColumn' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (col of dataToMerge.fields; track col) {
          <tr [attr.data-cy]="'mergetool-row-' + col">
            <th scope="row" class="merge-field" [attr.title]="col">{{ getLabel(col) }}</th>
            <td class="merge-cell" [attr.data-label]="'mergetool.localColumn' | translate">
              <button
                type="button"
                class="merge-choice is-local"
                [ngClass]="{ 'is-selected': getSelectedSide(col) === 'local' }"
                [attr.aria-pressed]="getSelectedSide(col) === 'local'"
                [attr.aria-label]="'mergetool.chooseLocal' | translate: { field: getLabel(col) }"
                [attr.data-cy]="'mergetool-local-' + col"
                (click)="pick($event, col, 'local')">
                <i aria-hidden="true" class="merge-check icon-check"></i>
                @if (formatValue(col, getLocalValue(col)); as v) {
                  <span class="merge-value">{{ v }}</span>
                } @else {
                  <span class="merge-value is-empty">{{ 'mergetool.empty' | translate }}</span>
                }
              </button>
            </td>
            <td class="merge-cell merge-result" [attr.data-cy]="'mergetool-merged-' + col">
              @if (formatValue(col, getMergedValue(col)); as v) {
                <span class="merge-value">{{ v }}</span>
              } @else {
                <span class="merge-value is-empty">{{ 'mergetool.empty' | translate }}</span>
              }
              @if (isMergedFallback(col)) {
                <span class="merge-default">{{ 'mergetool.defaultLocal' | translate }}</span>
              }
            </td>
            <td class="merge-cell" [attr.data-label]="'mergetool.remoteColumn' | translate">
              <button
                type="button"
                class="merge-choice is-remote"
                [ngClass]="{ 'is-selected': getSelectedSide(col) === 'remote' }"
                [attr.aria-pressed]="getSelectedSide(col) === 'remote'"
                [attr.aria-label]="'mergetool.chooseRemote' | translate: { field: getLabel(col) }"
                [attr.data-cy]="'mergetool-remote-' + col"
                (click)="pick($event, col, 'remote')">
                <i aria-hidden="true" class="merge-check icon-check"></i>
                @if (formatValue(col, getRemoteValue(col)); as v) {
                  <span class="merge-value">{{ v }}</span>
                } @else {
                  <span class="merge-value is-empty">{{ 'mergetool.empty' | translate }}</span>
                }
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="merge-footer">
    <div class="merge-bulk">
      <button
        pButton
        type="button"
        class="p-button p-button-secondary"
        data-cy="mergetool-keep-local"
        [disabled]="!localData"
        (click)="keepAll($event, 'local')"
        [label]="'mergetool.takeAllLocal' | translate"></button>
      <button
        pButton
        type="button"
        class="p-button p-button-secondary"
        data-cy="mergetool-keep-remote"
        (click)="keepAll($event, 'remote')"
        [label]="'mergetool.takeAllRemote' | translate"></button>
    </div>
    <button
      pButton
      type="button"
      class="p-button p-button-secondary"
      data-cy="mergetool-cancel"
      (click)="cancel($event)"
      [label]="'generic.cancel' | translate"></button>
    <button
      pButton
      type="button"
      class="p-button p-button-primary"
      data-cy="mergetool-save"
      [disabled]="!localData"
      (click)="save($event)"
      [label]="'mergetool.saveMerge' | translate"></button>
  </div>
</div>
